import { MailOutlined, PlusOutlined } from '@ant-design/icons';
import {
  Button,
  Checkbox,
  Form,
  Input,
  message,
  Modal,
  Select,
  Upload,
} from 'antd';
import { useState } from 'react';
import { CLOUDINARY } from 'utils/constants';
import { getBase64, normFile } from 'utils/utils';

const InviteUsersModal = ({ open, onCancel, onFinish, loading = false }) => {
  const [form] = Form.useForm();
  const [sendInvitationEmail, setSendInvitationEmail] = useState(false);
  const [image, setImage] = useState({});

  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      message.error('You can only upload JPG/PNG file!');
    }
    const isLt1M = file.size / 1024 / 1024 < 1;
    if (!isLt1M) {
      message.error('Image must be smaller than 1MB');
    }
    return isJpgOrPng && isLt1M;
  };

  const onChangeUpload = (info) => {
    if (info.file.status === 'uploading') {
      // setIsUploading(true);
      return;
    }
    if (info.file.status === 'done') {
      getBase64(info.file.originFileObj, (imageUrl) => {
        // setIsUploading(false);
        setImage({ imageUrl, picUrl: info.file.response.secure_url });
      });
    }
    if (info.file.status === 'error') {
      message.error('Error while uploading, please try again.');
      // setIsUploading(false);
      setImage({ imageUrl: null });
    }
  };
  return (
    <Modal
      destroyOnClose={true}
      open={open}
      footer={null}
      onCancel={() => {
        form.resetFields();
        onCancel();
      }}
      title="Invite someone on SimplePerf"
    >
      <Form
        layout="vertical"
        form={form}
        onFinish={(values) =>
          onFinish({
            ...values,
            ...(image && image.picUrl
              ? { profilePictureUrl: image.picUrl }
              : {}),
            sendInvitationEmail: values.sendInvitationEmail || false,
          })
            .then(() => {
              form.resetFields();
            })
            .catch(() => {
              // Do nothing or handle error if desired, but don't reset form
            })
        }
      >
        <Form.Item
          label={'Upload a picture of the employee:'}
          valuePropName="profilePictureUrl"
          getValueFromEvent={normFile}
        >
          <Upload
            beforeUpload={beforeUpload}
            onChange={onChangeUpload}
            maxCount={1}
            data={{
              upload_preset: CLOUDINARY.UPLOAD_PRESETS,
            }}
            listType="picture-card"
            action={`https://api.cloudinary.com/v1_1/${CLOUDINARY.CLOUD_NAME}/upload`}
          >
            <div>
              <PlusOutlined />
              <div style={{ marginTop: 8 }}>Upload</div>
            </div>
          </Upload>
        </Form.Item>
        <Form.Item label="First Name" name="firstName">
          <Input placeholder="First Name" />
        </Form.Item>
        <Form.Item label="Last Name" name="lastName">
          <Input placeholder="Last Name" />
        </Form.Item>
        <Form.Item
          label="Work Email"
          name="email"
          rules={[
            {
              required: true,
              type: 'email',
              message: 'Please input a valid email',
            },
          ]}
        >
          <Input placeholder="Enter a business email" />
        </Form.Item>
        <Form.Item label="Job Title" name="jobTitle">
          <Input placeholder="Enter a job title" />
        </Form.Item>
        <Form.Item
          label="Role"
          name="role"
          rules={[{ required: true, message: 'Please choose a role' }]}
        >
          <Select
            placeholder="Choose a role"
            options={[
              { value: 'USER', label: 'User' },
              { value: 'ADMIN', label: 'Admin' },
            ]}
          />
        </Form.Item>
        <Form.Item
          label={
            <span>
              <MailOutlined /> Invite the person by email?
            </span>
          }
          name="sendInvitationEmail"
          valuePropName="checked"
          onChange={(e) => {
            setSendInvitationEmail(e.target.checked);
          }}
        >
          <Checkbox children={<span>Send invitation Email</span>} />
        </Form.Item>
        <Form.Item>
          <Button
            loading={loading}
            type="primary"
            htmlType="submit"
            style={{ width: '100%' }}
          >
            {`Invite User ${
              sendInvitationEmail ? '(invite by email)' : '(no notification)'
            }`}
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default InviteUsersModal;
